<template>
<div class="single-as-triple mt-5">
    <template v-if="isBuilt">
        <div v-if="reloading" class="spinner element-spinner d-flex flex-column justify-content-center align-items-center">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>
        <h1 class="section-name col-12 mb-3 text-uppercase">{{tableData.name}}</h1>
        <div v-if="showQueries" v-html="this.query">{{ this.query }}</div>
        <template v-if="missed_some_metric.length">
            <div class="missed-accounts my-3">There is an issue with the section below. The issue is likely caused by no metrics connected. Change the metrics/remove this section in the builder.</div>
        </template>
        <template v-else-if="!!missed_accounts.length">
            <div v-for="missed_account in missed_accounts" class="missed-accounts my-3">There are no accounts connected for {{missed_account}}. Either connect an account or change the metrics/remove this section in the builder.</div>
        </template>
        <div v-if="no_data && !reloading" class="nodata-container p-5 text-center">
            <div v-if="errors || missed_some_metric.length" class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
            <div v-else class="empty-data"><img :src="$store.state.app_url+'/images/nodata.svg'"></div>
        </div>
        <div v-else class="row padding-x15 justify-content-lg-center three-cols">
            <template v-if="is_cta_performance">
                <div class="d-flex flex-column column1 justify-content-center is_cta_performance" :class="col5_flex">
                    <fieldset class="bordered col1 flex-grow-1">
                        <div class="row justify-content-center mt-3">
                            <div class="col first-column" :class="{'multiple':is_multiple, 'advert':is_advert_sources, 'has_total':!hide_total_row}">
                                <v-client-table :data="tblData1" :columns="columns1" :options="options1">
                                    <template v-for="column in columns1" :slot="column" slot-scope="props">
                                        <div class="text-wrap" :title="props.row[column]['title']">{{truncateString(props.row[column]['value'], 140)}}</div>
                                    </template>
                                </v-client-table>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div class="d-flex flex-column justify-content-center ml-1" :class="col5_flex">
                    <fieldset class="bordered col2 flex-grow-1">
                        <div class="row justify-content-center mt-3">
                            <div class="col fifth-column" :class="{'has_total':!hide_total_row}">
                                <v-client-table :data="tblData5" :columns="columns5" :options="options5">
                                    <template v-for="(column, idx) in columns5" :slot="column" slot-scope="props">
                                        <template v-if="show_arrow || show_percent_change">
                                            <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="props.row[column]['sign'] == 'na'">
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                        </template>
                                        <span v-else>{{props.row[column]['value']}}</span>
                                    </template>
                                </v-client-table>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </template>
            <template v-else-if="is_index_comparison">
                <div class="d-flex flex-column justify-content-center ml-1 is_index_comparison" :class="col5_flex">
                    <fieldset class="bordered col2 flex-grow-1">
                        <div class="row justify-content-center mt-3">
                            <div class="col index-comparison">
                                <v-client-table :data="tblData5" :columns="columns5" :options="options5">
                                    <template v-for="(column, idx) in columns5" :slot="column" slot-scope="props">
                                        <template v-if="(show_arrow || show_percent_change) && !(column == 'metric')">
                                            <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="props.row[column]['sign'] == 'na'">
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                        </template>
                                        <span v-else>{{props.row[column]['value']}}</span>
                                    </template>
                                </v-client-table>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </template>
            <template v-else>
                <div class="d-flex flex-column column1 justify-content-center" :class="col1_flex">
                    <fieldset class="bordered col1 flex-grow-1" :class="{'social-media':is_social_media}">
                        <template v-if="tableData.table_name">
                            <legend class="bordered text-uppercase" align="center">{{tableData.table_name}}</legend>
                        </template>
                        <template v-else>
                            <legend v-if="is_multiple" class="bordered text-uppercase" align="center">{{first_box_title}}</legend>
                            <legend v-else class="bordered text-uppercase" align="center">{{options1.headings.seg}}</legend>
                        </template>
                        <div class="row justify-content-center mt-3">
                            <div class="col first-column" :class="{'multiple':is_multiple, 'advert':is_advert_sources, 'has_total':!hide_total_row}">
                                <v-client-table :data="tblData1" :columns="columns1" :options="options1">
                                    <template v-for="column in columns1" :slot="column" slot-scope="props">
                                        <div class="text-wrap" :title="props.row[column]['title']">{{truncateString(props.row[column]['value'], 140)}}</div>
                                    </template>
                                </v-client-table>
                                <div v-if="show_definitions">
                                    <ul class="text-left">
                                        <li v-for="(definition, key) in definitions" class="definitions">
                                            <span class="definitions key">{{key}}</span><p><span class="definitions val">{{definition}}</span></p>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div v-if="num_metrics1" class="d-flex flex-column justify-content-center ml-1" :class="col2_flex">
                    <fieldset class="bordered col2 flex-grow-1">
                        <legend class="bordered text-uppercase" align="center">ENGAGEMENT</legend>
                        <div class="row justify-content-center mt-3">
                            <div class="col second-column" :class="{'has_total':!hide_total_row}">
                                <v-client-table :data="tblData2" :columns="columns2" :options="options2">
                                    <template v-for="(column, idx) in columns2" :slot="column" slot-scope="props">
                                        <template v-if="show_arrow || show_percent_change">
                                            <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="props.row[column]['sign'] == 'na'">
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                        </template>
                                        <span v-else>{{props.row[column]['value']}}</span>
                                    </template>
                                </v-client-table>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div v-if="num_metrics2" class="d-flex flex-column justify-content-center ml-1" :class="col3_flex">
                    <fieldset class="bordered col3 flex-grow-1">
                        <legend class="bordered text-uppercase" align="center">GOALS</legend>
                        <div class="row justify-content-center mt-3">
                            <div class="col third-column" :class="{'has_total':!hide_total_row}">
                                <v-client-table :data="tblData3" :columns="columns3" :options="options3">
                                    <template v-for="(column, idx) in columns3" :slot="column" slot-scope="props">
                                        <template v-if="show_arrow || show_percent_change">
                                            <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="props.row[column]['sign'] == 'na'">
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                        </template>
                                        <span v-else>{{props.row[column]['value']}}</span>
                                    </template>
                                </v-client-table>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div v-if="num_metrics3" class="d-flex flex-column justify-content-center ml-1" :class="col4_flex">
                    <fieldset class="bordered col4 flex-grow-1">
                        <template v-if="tableData.report_id == 283">
                            <legend class="bordered text-uppercase invisible" align="center">.</legend>
                        </template>
                        <template v-else>
                            <legend v-if="is_youtube" class="bordered text-uppercase" align="center">VIDEOS</legend>
                            <legend v-else class="bordered text-uppercase" align="center">ADWORDS</legend>
                        </template>
                        <div class="row justify-content-center mt-3">
                            <div class="col fourth-column" :class="{'has_total':!hide_total_row}">
                                <v-client-table :data="tblData4" :columns="columns4" :options="options4">
                                    <template v-for="(column, idx) in columns4" :slot="column" slot-scope="props">
                                        <template v-if="show_arrow || show_percent_change">
                                            <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="props.row[column]['sign'] == 'na'">
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                        </template>
                                        <span v-else>{{props.row[column]['value']}}</span>
                                    </template>
                                </v-client-table>
                            </div>
                        </div>
                    </fieldset>
                </div>
                <div v-if="num_metrics4" class="d-flex flex-column justify-content-center ml-1" :class="col5_flex">
                    <fieldset class="bordered col5 flex-grow-1" :class="{'linkedin':social_is_linkedin}">
                        <legend v-if="social_is_linkedin" class="bordered text-uppercase" align="center">LINKEDIN</legend>
                        <legend v-else-if="is_call_rail" class="bordered text-uppercase" align="center">CALL RAIL</legend>
                        <legend v-else class="bordered text-uppercase" align="center">FACEBOOK</legend>
                        <div class="row justify-content-center mt-3">
                            <div class="col fifth-column" :class="{'has_total':!hide_total_row}">
                                <v-client-table :data="tblData5" :columns="columns5" :options="options5">
                                    <template v-for="(column, idx) in columns5" :slot="column" slot-scope="props">
                                        <template v-if="show_arrow || show_percent_change">
                                            <span class="value-with-additionals" :class="'column-'+idx">{{props.row[column]['value']}}</span>
                                            <template v-if="props.row[column]['sign'] == 'na'">
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                            <template v-else>
                                                <span v-if="show_percent_change" class="arrow-wrap with-percentage" :class="[{'without-arrow':!show_arrow}, 'column-'+idx]"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}]"></span>{{props.row[column]['perc']}}%</span>
                                                <span v-else class="arrow-wrap without-percentage"><span :class="[props.row[column]['sign'], {'arrow':show_arrow}, 'column-'+idx]"></span></span>
                                            </template>
                                        </template>
                                        <span v-else>{{props.row[column]['value']}}</span>
                                    </template>
                                </v-client-table>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </template>
        </div>
    </template>
</div>
</template>

<script>
    export default {
        props: ['isBuilt', 'hasSkb', 'tableData'],
        created() {
            if(this.isBuilt){
                this.show_arrow = this.tableData.element_configurations.show_arrows;
                this.show_percent_change = this.tableData.element_configurations.show_percent_change;
                this.show_definitions = !!this.tableData.reporting_table_type_configurations && !!this.tableData.reporting_table_type_configurations.show_definitions ? this.tableData.reporting_table_type_configurations.show_definitions : null;
                this.hide_total_row = this.tableData.element_configurations.hide_total_row;
                this.is_social_media = this.tableData.segment['table_type'] == 'Social Media Advertising';
                this.is_advert_sources = this.tableData.segment['table_type'] == 'Advertising Sources';
                this.is_campaign_groupings = this.tableData.segment['table_type'] == 'Campaign Groupings';
                this.is_goal_breakdown = this.tableData.segment['table_type'] == 'Goal Breakdown';
                this.is_cta_performance = this.tableData.segment['table_type'] == 'CTA Performance';
                this.is_index_comparison = this.tableData.segment['table_type'] == 'Index Comparison';
                this.is_channel_grouping = this.tableData.segment['db_column'] == 'channel_grouping';
                this.is_youtube = this.tableData.segment['table_type'] == 'Video Campaigns';
                this.show_index_values = this.is_goal_breakdown ? this.tableData.element_configurations.show_index_values : false;
                this.index_name = this.show_index_values ? this.tableData.element_configurations.select_index_name : null;
                this.num_rows = this.is_goal_breakdown ? 100 : this.tableData.element_configurations.num_rows;
                this.is_multiple = this.is_social_media || this.is_advert_sources;
                this.first_box_title = this.is_social_media ? 'Social Media Advertising' : (this.is_advert_sources ? 'Advertising Sources' : '');
                this.split_by = this.is_advert_sources ? this.tableData.reporting_table_type_configurations.split_by : null;
                this.ad_type = this.is_advert_sources ? this.tableData.reporting_table_type_configurations.ad_type : null;
                this.exclude_branded_terms = (this.tableData.segment.table_type == 'Keywords' && !!this.tableData.reporting_table_type_configurations) ? this.tableData.reporting_table_type_configurations.exclude_branded_terms : false;
                this.language_filter = (this.tableData.segment.table_type == 'Keywords' && !!this.tableData.reporting_table_type_configurations) ? this.tableData.reporting_table_type_configurations.language_filter : false;
                this.terms_to_include = (this.tableData.segment.table_type == 'Keywords' && !!this.tableData.reporting_table_type_configurations) ? this.tableData.reporting_table_type_configurations.terms_to_include : false;
                this.show_channel_groupings = (this.tableData.segment.table_type == 'Campaigns' && !!this.tableData.reporting_table_type_configurations) ? this.tableData.reporting_table_type_configurations.show_channel_groupings : false;
                this.campaign_groupings = this.is_campaign_groupings ? this.tableData.reporting_table_type_configurations.campaign_groupings : null;
                this.index_comparison = this.is_index_comparison ? this.tableData.reporting_table_type_configurations.index_comparison : null;
                this.filter_element = this.tableData.element_configurations.filter_element;
                this.fetchServerData();
                this.missed_some_metric = this.checkMissedTables(this.tableData);
                this.missed_accounts = this.checkAccounts(this.tableData);
                if(this.is_channel_grouping){
                    this.col1_flex = 'flex-1';
                }
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.reloading = true;
                this.fetchServerData();
            });
        },
        updated(){
            $('table.VueTables__table').each(function(idx, el){
                const table = $(el);
                for(let i=0;i<10;i++){
                    let max_w = 0;
                    table.find('span.value-with-additionals.column-'+i).each(function(i, e){
                        max_w = Math.max(max_w, parseInt($(e).width()));
                    });
                    table.find('span.value-with-additionals.column-'+i).width(max_w);
                    max_w = 0;
                    table.find('span.arrow-wrap.column-'+i).each(function(i, e){
                        max_w = Math.max(max_w, parseInt($(e).width()));
                    });
                    table.find('span.arrow-wrap.column-'+i).width(max_w);
                }

            });
            let h = 0;
            $('thead th').find('span').each(function(idx, el){
                h = Math.max(h, $(el).height());
            });
            $('thead th').find('span').height(h + 'px');
        },
        data() {
            return {
                missed_accounts:[],
                missed_some_metric:[],
                isArchive:this.$store.state.isArchive,
                filter_element: null,
                segment_name:null,
                num_metrics1:null,
                num_metrics2:null,
                num_metrics3:null,
                num_metrics4:null,
                col1_flex:'flex-2',
                col2_flex:'flex-1',
                col3_flex:'flex-1',
                col4_flex:'flex-1',
                col5_flex:'flex-1',
                columns1:[],
                columns2:[],
                columns3:[],
                columns4:[],
                columns5:[],
                options1:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                options2:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                options3:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                options4:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                options5:{
                    headings:{},
                    filterable:false,
                    sortable: [],
                    texts:{
                        count:''
                    },
                    skin: 'table'
                },
                tblData1:[],
                tblData2:[],
                tblData3:[],
                tblData4:[],
                tblData5:[],
                num_rows:5,
                show_arrow:false,
                show_percent_change:false,
                hide_total_row:false,
                is_social_media:false,
                is_advert_sources:false,
                is_campaign_groupings:false,
                is_goal_breakdown:false,
                is_index_comparison:false,
                is_cta_performance:false,
                is_channel_grouping:false,
                is_multiple:false,
                is_youtube:false,
                split_by:null,
                ad_type:null,
                first_box_title:'',
                exclude_branded_terms:false,
                language_filter:false,
                terms_to_include:false,
                show_channel_groupings:false,
                social_is_linkedin:false,
                is_call_rail:false,
                show_definitions:false,
                definitions:null,
                show_index_values:false,
                index_name:null,
                query:'',
                showQueries: this.$store.state.showQueries,
                no_data:false,
                errors:false,
                reloading:true
            }
        },

        methods: {
            fetchServerData(){
                const params = {
                    'isArchive':this.isArchive,
                    'prefixed_id': this.isArchive ? this.tableData.archive_id : this.tableData.report_id,
                    'element_abbr':this.tableData.element_abbreviation,
                    'show_as_triple':true,
                    'dwm':this.$store.state.current_dwm,
                    'dates':this.$store.state.current_dates,
                    'element_id': this.tableData.element_id,
                    'prefixed_element_id': this.tableData.report_element_id,
                    'element_name':this.tableData.name,
                    'metrics': this.tableData.metrics,
                    'segment': this.tableData.segment,
                    'accounts': this.tableData.accounts,
                    'num_rows':this.num_rows,
                    'show_arrow':this.show_arrow,
                    'show_percent_change':this.show_percent_change,
                    'hide_total_row':this.hide_total_row,
                    'client_id':this.tableData.client_id,
                    'client_name':this.tableData.client_name,
                    'split_by':this.split_by,
                    'ad_type':this.ad_type,
                    'exclude_branded_terms':this.exclude_branded_terms,
                    'language_filter':this.language_filter,
                    'terms_to_include':this.terms_to_include,
                    'show_channel_groupings':this.show_channel_groupings,
                    'campaign_groupings':this.campaign_groupings,
                    'index_comparison':this.index_comparison,
                    'show_index_values': this.show_index_values,
                    'index_name':this.index_name,
                    'rules':this.tableData.rules,
                    'filter_element':this.filter_element,
                    'showQueries':this.showQueries,
                    'hasSkb':this.hasSkb,
                };

                axios.post('/api/reporting/element', params).then((response) => {
                    if(!!response.data && (typeof(response.data) == 'object')){
                        let data = response.data;
                        this.query = data.query;
                        this.errors = data['errors'];
                        if(!this.errors){
                            this.columns1 = _.has(data, 'table_1') ? data.table_1.columns : [];
                            this.columns2 = _.has(data, 'table_2') ? data.table_2.columns : [];
                            this.columns3 = _.has(data, 'table_3') ? data.table_3.columns : [];
                            this.columns4 = _.has(data, 'table_4') ? data.table_4.columns : [];
                            this.columns5 = _.has(data, 'table_5') ? data.table_5.columns : [];
                            this.options1.headings = _.has(data, 'table_1') ? data.table_1.headings : [];
                            this.options2.headings = _.has(data, 'table_2') ? data.table_2.headings : [];
                            this.options3.headings = _.has(data, 'table_3') ? data.table_3.headings : [];
                            this.options4.headings = _.has(data, 'table_4') ? data.table_4.headings : [];
                            this.options5.headings = _.has(data, 'table_5') ? data.table_5.headings : [];
                            this.tblData1 = _.has(data, 'table_1') ? data.table_1.tblData : [];
                            this.tblData2 = _.has(data, 'table_2') ? data.table_2.tblData : [];
                            this.tblData3 = _.has(data, 'table_3') ? data.table_3.tblData : [];
                            this.tblData4 = _.has(data, 'table_4') ? data.table_4.tblData : [];
                            this.tblData5 = _.has(data, 'table_5') ? data.table_5.tblData : [];
                            this.segment_name = this.tableData.segment.segment_name;
                            this.num_metrics1 = !!this.tblData2[0] ? Object.keys(this.tblData2[0]).length : 0;
                            this.num_metrics2 = !!this.tblData3[0] ? Object.keys(this.tblData3[0]).length : 0;
                            this.num_metrics3 = !!this.tblData4[0] ? Object.keys(this.tblData4[0]).length : 0;
                            this.num_metrics4 = !!this.tblData5[0] ? Object.keys(this.tblData5[0]).length : 0;
                            this.social_is_linkedin = this.num_metrics4 && data.social_is_linkedin;
                            this.is_call_rail = this.num_metrics4 && data.is_call_rail;
                        }
                        if(this.show_definitions){
                            this.definitions = response.data.definitions;
                        }
                        this.checkFlexVal();
                        this.no_data = data.no_data;
                    }

                    this.reloading = false;
                });
            },
            checkFlexVal(){
                let col_min = 0;
                let col_max = 0;
                let num_col_max = 0;
                if(this.columns2.length > 0){
                    col_min = this.columns2.length;
                    col_max = this.columns2.length;
                    num_col_max = 2;
                }
                for(let i=3;i<6;i++){
                    if(this['columns'+i].length > 0){
                        col_min = Math.min(col_min, this['columns'+i].length);
                        col_max = Math.max(col_max, this['columns'+i].length);
                        if(col_max == this['columns'+i].length){
                            num_col_max = i;
                        }
                    }
                }

                if(col_min != 0 && Math.round(col_max/col_min) > 1){
                    this['col'+num_col_max+'_flex'] = 'flex-2';
                }
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.three-cols{
        div.text-wrap{
            @media screen and (max-width: 992px) {
                white-space:nowrap !important;
            }
        }
        flex-wrap: nowrap;
        overflow:auto;
        .VueTables__table {
            th, td {
                font-size: 1.44rem;
            }
        }
        .table{
            margin-bottom:0 !important;
        }
        .flex-1{
            flex:1;
        }
        .flex-2{
            flex:2;
        }
        div.first-column:not(:multiple){
            div.table-responsive{
                overflow:hidden;
                position:relative;
                table, tbody{
                    display:block !important;
                    max-width:100%;
                }
            }
        }
        fieldset.bordered {
            border-radius:2rem;
            padding: 0 0.05rem 1rem 0.05rem !important;
            margin: 0 !important;
            text-align:center;
            tbody tr {
                line-height:1.5;
                font-size:1.125vw;
                @media screen and (max-width: 992px) {
                    font-size:2.2vw !important;
                }
            }
            thead th{
                border-bottom:none !important;
                text-transform:uppercase !important;
                min-width:5.5rem;
                span{
                    display:inline-block;
                }
                font-size:0.8vw;
                @media screen and (max-width: 992px) {
                    font-size:2.2vw !important;
                }
                @media screen and (min-width: 1260px) and (max-width: 1500px) {
                    font-size:0.9vw;
                }
            }
            tbody tr td{
                line-height:1.6rem;
                height:4.8rem;
            }
            span.value-with-additionals{
                display:inline-block;
                text-align:right;
            }
            span.arrow-wrap{
                font-size:0.625vw;
                @media screen and (max-width: 992px) {
                    font-size:2.2vw !important;
                }
                display:inline-block;
                text-align:left;
                span.arrow {
                    &::before {
                        border-left: 0.5vw solid transparent;
                        border-right: 0.5vw solid transparent;
                        content: "";
                        display: inline-block;
                        height: 0;
                        width: 0;
                        margin-left:1rem;
                        margin-right:0.2rem;
                    }
                }
                &.without-arrow{
                    margin-left:1rem;
                }
            }
            &.col1{
                border: 0.25rem solid $black-blue !important;
                legend{
                    color:$black-blue;
                }
                tbody tr {
                    color:$black-blue;
                    &:nth-child(odd){
                        background-color:$strip-gray1;
                    }
                    td{
                        word-break: break-word;
                        &:nth-child(1){
                            div{
                                min-width:12rem;
                            }
                        }
                        &:nth-child(2){
                            div{
                                min-width:7rem;
                            }
                        }
                    }
                }
                &.social-media{
                    tbody tr {
                        td{
                            &:nth-child(1){
                               text-transform:uppercase;
                            }
                        }
                    }
                }
            }
            &.col2{
                border: 0.25rem solid $light-blue !important;
                legend{
                    color:$light-blue;
                }
                tbody tr {
                    color:$light-blue;
                    &:nth-child(odd){
                        background-color:$strip-gray2;
                    }
                    td{
                        text-align:center;
                        white-space:nowrap;
                        font-size:1.2vw !important;
                        @media screen and (max-width: 992px) {
                            font-size:2.2vw !important;
                        }
                    }
                }
                th{
                    text-align:center;
                    color:$light-blue;
                }
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom: 0.8rem dashed $light-blue;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 0.8rem dashed $light-blue;
                        }
                    }
                }
            }
            &.col3{
                border: 0.25rem solid $gold !important;
                legend{
                    color:$gold;
                }
                tbody tr {
                    color:$gold;
                    &:nth-child(odd){
                        background-color:$strip-gray3;
                    }
                    td{
                        text-align:center;
                        white-space:nowrap;
                        font-size:1.2vw !important;
                        @media screen and (max-width: 992px) {
                            font-size:2.2vw !important;
                        }
                    }
                }
                th{
                    text-align:center;
                    color:$gold;
                }
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom: 0.8rem dashed $gold;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 0.8rem dashed $gold;
                        }
                    }
                }
            }
            &.col4{
                border: 0.25rem solid $dark-orange !important;
                legend{
                    color:$dark-orange;
                }
                tbody tr {
                    color:$dark-orange;
                    &:nth-child(odd){
                        background-color:$strip-gray3_1;
                    }
                    td{
                        text-align:center;
                        white-space:nowrap;
                        font-size:1.2vw !important;
                        @media screen and (max-width: 992px) {
                            font-size:2.2vw !important;
                        }
                    }
                }
                th{
                    text-align:center;
                    color:$dark-orange;
                }
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom: 0.8rem dashed $dark-orange;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 0.8rem dashed $dark-orange;
                        }
                    }
                }
            }
            &.col5{
                border: 0.25rem solid $facebook-blue !important;
                legend{
                    color:$facebook-blue;
                }
                tbody tr {
                    color:$facebook-blue;
                    &:nth-child(odd){
                        background-color:$strip-gray2;
                    }
                    td{
                        text-align:center;
                        white-space:nowrap;
                        font-size:1.2vw !important;
                        @media screen and (max-width: 992px) {
                            font-size:2.2vw !important;
                        }
                    }
                }
                th{
                    text-align:center;
                    color:$facebook-blue;
                }
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom: 0.8rem dashed $facebook-blue;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 0.8rem dashed $facebook-blue;
                        }
                    }
                }
            }
            &.col5.linkedin{
                border: 0.25rem solid $linkedin-blue !important;
                legend{
                    color:$linkedin-blue;
                }
                tbody tr {
                    color:$linkedin-blue;
                }
                th{
                    color:$linkedin-blue;
                }
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom: 0.8rem dashed $linkedin-blue;
                        }
                    }
                    &.down{
                        &::before {
                            border-top: 0.8rem dashed $linkedin-blue;
                        }
                    }
                }
            }
        }

        legend.bordered {
            font-size: 1.2vw !important;
            @media screen and (max-width: 992px) {
                font-size:2.2vw !important;
            }
            text-align: center !important;
            width:auto;
            padding:0 1rem;
            border-bottom:none;
            color:$light-blue;
            white-space:nowrap;
        }

        .VuePagination{
            display:none;
        }
        .has_total{
            tbody tr:last-child {
                background-color:black !important;
                color:white !important;
                span.arrow {
                    &.up{
                        &::before {
                            border-bottom-color: white !important;
                        }
                    }
                    &.down{
                        &::before {
                            border-top-color: white !important;
                        }
                    }
                }
            }

            .table{
                margin-bottom:1.6rem !important;
            }
        }
        li.definitions{
            span.definitions{
                font-size:1.2rem;
                @media screen and (max-width: 992px) {
                    font-size:2.2vw !important;
                }
                &.key{
                    color:$black-blue;
                    font-weight:bold;
                    white-space:nowrap;
                }
                &.val{
                    color:$gray-darker;
                }
            }
            p{
                margin-bottom:0 !important;
            }
            &::marker{
                color:$black-blue;
            }
        }
    }
    div.index-comparison{
        thead th{
            padding-bottom:2.5rem;
        }
    }
    div.nodata-container{
        background-color:white;
    }
    div.bordered.invisible{
        color:white;
    }
    tr.VueTables__no-results{
        td{
            text-transform:uppercase;
        }
    }
</style>
